import React, { FunctionComponent } from "react";

import RichText from "../richtext";
import { ITextSection, ITextSectionFields } from "@/types/generated/contentful";

type Props = {
  content: ITextSection;
};

const TextSection: FunctionComponent<Props> = ({ content }) => {
  const {
    content: textContent,
    strongColor,
    fontSize,
    textAlignment,
    verticalAlignment,
    background,
    foreground,
    backgroundOverlayImage,
    backgroundOverlayType,
  } = content.fields as ITextSectionFields;

  let size = "text-xl";
  let textAlign = "text-left";

  switch (fontSize) {
    case "sm":
      size = "text-sm";
      break;
    case "md":
      size = "text-md";
      break;
    case "base":
      size = "text-base";
      break;
    case "xl":
      size = "text-xl";
      break;
  }

  switch (textAlignment) {
    case "center":
      textAlign = "justify-center text-center";
      break;
    case "right":
      textAlign = "justify-end text-right";
      break;
    default:
      textAlign = "justify-left text-left";
      break;
  }
  let verticalAlign = "";
  switch (verticalAlignment) {
    case "middle":
      verticalAlign = "items-center";
      break;
    case "bottom":
      verticalAlign = "items-end";
      break;
    case "top":
    default:
      verticalAlign = "items-start";
      break;
  }

  return (
    <section
      className={`flex h-full ${verticalAlign} rounded-xl ${background || backgroundOverlayImage ? "px-4 py-12" : "p-2"} ${textAlign}`}
      style={{
        backgroundColor: background || "transparent",
        ...(foreground && { color: foreground }),
        ...(backgroundOverlayImage?.fields.file?.url && {
          backgroundImage:
            "url('" + backgroundOverlayImage?.fields.file?.url + "')",
        }),
        backgroundSize: backgroundOverlayType,
        ...(backgroundOverlayType === "contain" && {
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }),
      }}
    >
      <RichText
        content={textContent}
        strongColor={strongColor}
        textSize={size}
      />
    </section>
  );
};

export default TextSection;
